import React, { useState } from 'react';

import { Flex } from 'antd-v5';
import { FormattedMessage } from 'react-intl';
import { Button, Select } from 'scouting-ui/lib';

import { intl } from '@shared/localization';

import type { AppliedClassEntry, MBClass } from '../types';
import styles from './ClassEntry.module.scss';
import MBClassLabel from './MBClassLabel';

interface ClassFiltersProps {
  classes: MBClass[];
  loading: boolean;
  applied?: AppliedClassEntry;
  onApply: (applied: AppliedClassEntry) => void;
}

export default function ClassFilters(props: ClassFiltersProps) {
  const { classes, loading, applied, onApply } = props;

  const [classId, setClassId] = useState(applied?.classId);
  const [versionId, setVersionId] = useState(applied?.versionId);

  const findClass = (id: unknown) =>
    classes.find(mbClass => mbClass.id === Number(id));
  const selectedClass = findClass(classId);

  const renderClass = (id: unknown, size: 'sm' | 'md') => {
    const mbClass = findClass(id);
    return mbClass ? <MBClassLabel mbClass={mbClass} size={size} /> : null;
  };

  return (
    <Flex wrap gap={14} align="center">
      <div className={styles.filterField}>
        <Select
          id="class-entry-class"
          placeholder={intl.formatMessage({ id: 'page.mbcClassEntry.class' })}
          value={classId}
          loading={loading}
          showSearch
          optionFilterProp="label"
          options={classes.map(mbClass => ({
            value: mbClass.id,
            label: mbClass.label,
          }))}
          labelRender={item => renderClass(item.value, 'sm')}
          optionRender={item => renderClass(item.value, 'md')}
          onChange={(value: number) => {
            setClassId(value);
            setVersionId(findClass(value)?.defaultVersionId);
          }}
        />
      </div>
      <div className={styles.filterField}>
        <Select
          id="class-entry-mb-version"
          placeholder={intl.formatMessage({
            id: 'page.mbcClassEntry.version',
          })}
          value={versionId}
          disabled={!selectedClass}
          options={selectedClass?.versions.map(version => ({
            value: version.versionId,
            label: version.label,
          }))}
          onChange={(value: number) => setVersionId(value)}
        />
      </div>
      <Button
        type="default"
        disabled={!classId || !versionId}
        onClick={() => onApply({ classId: classId!, versionId: versionId! })}
      >
        <FormattedMessage id="shared.apply" />
      </Button>
    </Flex>
  );
}
